import { CloudUpload, RefreshCw, Smartphone, Wifi, WifiOff } from 'lucide-react';
import { useInRouterContext, useNavigate } from 'react-router-dom';
import { useLocalOnly } from '../lib/local';
import { useT, tr } from '../lib/i18n';
import { FLUSH_EVERY_MS, syncNow, useSync } from '../lib/sync';

const hm = (t: number) => new Date(t).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });

export function SyncPill({ compact = false }: { compact?: boolean }) {
  const { online, syncing, pending, error, lastSync } = useSync();
  const tx = useT();
  const inRouter = useInRouterContext();
  // Phone-only (Starter): nothing syncs, so say where the data is instead.
  if (useLocalOnly()) return inRouter ? <PhonePill compact={compact} /> : <span className={PHONE}><Smartphone size={13} strokeWidth={2.25} aria-hidden />{tx('On this phone')}</span>;
  let tone = 'bg-t-green text-t-green-fg';
  let Icon = Wifi;
  let text = compact ? tx('Live') : lastSync ? tx('Synced {t}', { t: hm(lastSync) }) : tx('Online');
  if (!online) { tone = 'bg-t-amber text-t-amber-fg'; Icon = WifiOff; text = pending ? tx('Offline · {n} queued', { n: pending }) : tx('Offline'); }
  else if (syncing) { tone = 'bg-t-blue text-info'; Icon = RefreshCw; text = tx('Syncing…'); }
  else if (error) { tone = 'bg-t-red text-danger'; Icon = CloudUpload; text = tx('Sync error'); }
  else if (pending) { tone = 'bg-t-blue text-info'; Icon = CloudUpload; text = tx('{n} to sync', { n: pending }); }
  return (
    <button onClick={() => void syncNow()}
      title={error ?? tr('{0}{1} · click to sync now', { 0: lastSync ? `Last synced ${hm(lastSync)}, next by ${hm(lastSync + FLUSH_EVERY_MS)}` : tr('Not synced yet'), 1: pending ? ` · ${pending} waiting` : '' })}
      className={`inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full px-3 text-xs font-semibold ${tone}`}>
      <Icon size={13} strokeWidth={2.25} className={syncing ? 'animate-spin' : ''} aria-hidden />
      {text}
    </button>
  );
}

const PHONE = 'inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-t-teal px-3 text-xs font-semibold text-t-teal-fg';

function PhonePill({ compact }: { compact: boolean }) {
  const navigate = useNavigate();
  const tx = useT();
  return (
    <button onClick={() => navigate('/settings/sync')} title={tr('Starter keeps data on this phone · upgrade to back up')} className={PHONE}>
      <Smartphone size={13} strokeWidth={2.25} aria-hidden />
      {compact ? tx('Phone') : tx('On this phone')}
    </button>
  );
}
